import { useTranslation } from "react-i18next";
import { cn } from "@/utils/cn";
import { Button } from "../ui/button";
import { FilterIcon, RotateCcw } from "lucide-react";

interface IFilterButtonProps {
  onClick: () => void;
  filtersCount: number;
  onReset?: () => void;
  className?: string;
}

const FilterButton = ({
  onClick,
  filtersCount,
  onReset,
  className,
}: IFilterButtonProps) => {
  const { t } = useTranslation("common");
  const isActive = filtersCount > 0;
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        className={cn(
          "font-normal gap-2 p-2",
          isActive
            ? "border-primary text-primary bg-primary/5 hover:bg-primary/10"
            : "text-muted-foreground bg-transparent",
          className,
        )}
        onClick={onClick}
      >
        <FilterIcon className="size-3.5 lg:size-4" />
        <span className="hidden md:block text-xs lg:text-sm">
          {t("shared_ui.filters")}
        </span>
        {isActive && (
          <span className="text-xs bg-primary text-primary-foreground rounded-full w-5 h-5 flex items-center justify-center font-semibold">
            {filtersCount}
          </span>
        )}
      </Button>
      {isActive && onReset && (
        <Button
          variant="ghost"
          className="font-normal gap-1.5 p-2 text-muted-foreground hover:text-danger"
          onClick={onReset}
          title={t("ui_kit.reset_filters")}
        >
          <RotateCcw className="size-3.5 lg:size-4" />
          <span className="hidden md:block text-xs lg:text-sm">
            {t("buttons.reset")}
          </span>
        </Button>
      )}
    </div>
  );
};

export default FilterButton;
